module.exports = __webpack_public_path__ + "img/chat.de4e2156.svg";